import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import { updateRole } from 'slices/auth';

export const list = 'LIST_ROLES';
export const single = 'SINGLE_ROLE';

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createRole: builder.mutation({
      query: (role) => ({
        url: '/roles/create',
        method: 'POST',
        body: role
      })
    }),
    updateRole: builder.mutation({
      query: ({ roleId, ...attributes }) => ({
        url: `/roles/update/${roleId}`,
        method: 'POST',
        body: { ...attributes }
      })
    }),
    listRoles: builder.query({
      query: (params) => ({
        url: '/roles/list',
        params
      }),
      async onQueryStarted(params, { dispatch, getState, queryFulfilled }) {
        try {
          if (!params?.projection) {
            const { data } = await queryFulfilled;
            const role = data?.data?.items?.find((role) => role.id === getState().auth.role?.id);
            if (role) {
              dispatch(updateRole(role));
            }
          }
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      },
      providesTags: [list]
    }),
    savePermissions: builder.mutation({
      query: (body) => ({
        url: `/roles/save-permissions`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: [list]
    })
  })
});

export const { useCreateRoleMutation, useUpdateRoleMutation, useListRolesQuery, useSavePermissionsMutation } = rolesApi;
